<template>
    <div class="page">
        <div class="wrapper">
            <div class="loader" v-if="!finished">
                <img src="/assets/images/talents/loader.gif" style="width:24px;padding:10px;">
                <div class="uploading">Je inschrijving wordt verwerkt. 1 moment geduld alstjeblieft</div>
                <br><br>
                <div class="att" style="font-size: 1.2rem;color:#ff5100">NB: sluit je browser niet af tot we klaar zijn met het versturen van je data</div>
            </div>
            <div class="upload-done" v-if="finished">
                <h1>Gelukt!</h1>

                <p>
                    Bedankt voor de aanmelding!<br/>
                    Je ontvangt per e-mail een bevestiging.
                </p>
            </div>

        </div>
    </div>
</template>
<script type='text/babel'>

    export default {
        components: {
        },
        data: () => ({
            'finished': false
        }),
        mounted() {
            this.finsishIt();
        },
        computed: {
        },
        methods: {
            finsishIt(){
                axios.get('/finish').then((response) => {
                    this.finished = true;
                })
            }
        },
    };
</script>